const initialState = {
    getResult: [],
    getLoading: false,
    getError:false
}

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_USERS":   
            return {
                ...state,
                getResult: action.payload.data,
                getLoading: action.payload.loading,
                getError: action.payload.errorMessage
            }
        default:
            return {
                ...state
            }
    }
}

export default userReducer